import BreadcrumbSeparator from 'antd/es/breadcrumb/BreadcrumbSeparator';
// export default withConfigProvider(BreadcrumbSeparator as BreadcrumbSeparatorInterface);
export default BreadcrumbSeparator;
